/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppealTopicBlock } from '../models/AppealTopicBlock';
import type { MailClaimSendBody } from '../models/MailClaimSendBody';
import { request as __request } from '../core/request';

export class AppealsService {

    /**
     * @returns AppealTopicBlock Ok
     * @throws ApiError
     */
    public static async getAppealsTopics(): Promise<AppealTopicBlock> {
        const result = await __request({
            method: 'GET',
            path: `/appeals/topics`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async sendAppeal(
        requestBody: MailClaimSendBody,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/appeals/send`,
            body: requestBody,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}